import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import {
  ALL_DEPARTMENT_OBSERVATION,
  ENGINEERING_DEPARTMENT_OBSERVATION,
  HANDOVER_OBSERVATION_DATA_DIALOG_TITLE,
  HANDOVER_OBSERVATION_WELL_CONDITION,
  HANDOVER_OBSERVATION_WELL_CONDITION_DIALOG_TITLE,
  HANDOVER_REJECT_NOT_OK_MESSAGE,
  HANDOVER_REJECT_OK_MESSAGE,
  HANDOVER_SECTION_GENERAL,
  HANDOVER_TYPE_HO2_ID,
  HANDOVER_TYPE_HO3_ID,
  HANDOVER_TYPE_HO4_ID,
  HANDOVER_TYPE_HO5_ID,
  HANDOVER_TYPE_HOEC_ID,
  OPERATIONS_DEPARTMENT_OBSERVATION,
  PAE_SUPPORT_EMAIL,
  PERMISSION_ACCEPT_HO,
  PERMISSION_ENGINEERING_COMPLETION,
  SUCCESS_TIME_MESSAGE,
} from 'src/app/handover-constants';
import { Handover } from 'src/app/interfaces/handover';
import {
  HandoverHistoryObservation,
  HandoverObservation,
  HandoverReceiverObservation,
  ObservationAttachment,
} from 'src/app/interfaces/handover-observation';
import { SectionsComments } from 'src/app/interfaces/section-comment';
import { DialogService } from 'src/app/services/dialog.service';
import { HandoverService } from 'src/app/services/handover.service';
import { NotificationService } from 'src/app/services/notification.service';
import { UserService } from 'src/app/services/user.service';
import {
  HoAcceptMessages,
  HoRejectMessages,
} from '../handover-detail-footer-receiver/handover-detail-footer-messages';
import { HttpErrorResponse } from '@angular/common/http';
import { PendingChanges } from '../shared/pending-changes.class';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-handover-detail-footer-receivers',
  templateUrl: './handover-detail-footer-receivers.component.html',
  styleUrls: ['./handover-detail-footer-receivers.component.scss'],
  standalone: false,
})
export class HandoverDetailFooterReceiversComponent
  extends PendingChanges
  implements OnInit
{
  @Input() handover: Handover | undefined;
  @Input() readOnlyContent!: boolean;
  @Output() isLoadingEmmitter = new EventEmitter<boolean>();

  observations: HandoverObservation[] = [];
  engineeringOservations: HandoverObservation[] = [];
  historyObservations: HandoverHistoryObservation[] = [];
  isDisabledButton = false;
  fullscreen = true;
  firstTime = true;
  viewHistory: {
    handoverObservationTypeId: number;
    viewHistory: boolean;
  }[] = [];
  havePermissionAccept = false;
  rejectButtonToolTip = '';
  generalComment: string | undefined = '';
  firstReject = true;
  operationsVisible = true;
  isDr = false;
  isEngineerUser = false;
  isHo3 = false;
  fileLimit = 1;
  observationAttachment: any;
  observationOperationsAttachment: any;
  observationEngineerAttachment: any;
  dhoApiUrl = `${environment.urlBackend}/dhoapi`;

  constructor(
    private dialogService: DialogService,
    private handoverService: HandoverService,
    private notificationService: NotificationService,
    private router: Router,
    private userService: UserService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private datepipe: DatePipe
  ) {
    super();
    this.matIconRegistry.addSvgIcon(
      'check-fill-green',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../../assets/check-fill-green.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'close-fill-red',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../../assets/close-fill-red.svg'
      )
    );
    this.rejectButtonToolTip = HANDOVER_REJECT_NOT_OK_MESSAGE;
  }

  ngOnInit(): void {
    this.havePermissionAccept =
      this.userService.hasPermission(PERMISSION_ACCEPT_HO);
    this.isEngineerUser = this.userService.hasPermission(
      PERMISSION_ENGINEERING_COMPLETION
    );
    this.isHo3 = this.handover!.handoverTypeId! == HANDOVER_TYPE_HO3_ID;
    this.isDr = [
      HANDOVER_TYPE_HO2_ID,
      HANDOVER_TYPE_HO4_ID,
      HANDOVER_TYPE_HO5_ID,
      HANDOVER_TYPE_HOEC_ID,
    ].includes(this.handover!.handoverTypeId!);

    this.getLastObservations();
    this.getLastEngineeringObservations();
    this.getObservations();
    this.getGeneralSectionComment();
    this.getObservationAttachments();
  }

  reject(): void {
    let engineeringObservation;
    const receiverObservations: HandoverReceiverObservation[] = [];
    const datetime = this.datepipe.transform(Date.now(), 'yyyy-MM-dd HH:mm:ss');
    if (this.firstReject) {
      for (let index = 0; index < this.observations.length; index++) {
        const observation = this.observations[index];
        engineeringObservation = { ...this.observations[index] };
        if (observation.handoverObservationChecked) {
          receiverObservations.push({
            handoverObservationTypeId: observation.handoverObservationTypeId,
            receiverObservation: observation.handoverObservation,
            receiverUserId: this.userService.getUserProperties().userId,
            receiverObservationDatetime: datetime,
            departmentObservation: OPERATIONS_DEPARTMENT_OBSERVATION,
          } as HandoverReceiverObservation);
          receiverObservations.push({
            handoverObservationTypeId:
              engineeringObservation?.handoverObservationTypeId,
            receiverObservation: engineeringObservation?.handoverObservation,
            receiverUserId: this.userService.getUserProperties().userId,
            receiverObservationDatetime: datetime,
            departmentObservation: ENGINEERING_DEPARTMENT_OBSERVATION,
          } as HandoverReceiverObservation);
        }
      }
    } else {
      for (let index = 0; index < this.observations.length; index++) {
        const observation = this.observations[index];
        if (observation.handoverObservationChecked) {
          receiverObservations.push({
            handoverObservationTypeId: observation.handoverObservationTypeId,
            receiverObservation: observation.handoverObservation,
            receiverUserId: this.userService.getUserProperties().userId,
            receiverObservationDatetime: datetime,
            departmentObservation: OPERATIONS_DEPARTMENT_OBSERVATION,
          } as HandoverReceiverObservation);
        }
      }
      for (let index = 0; index < this.engineeringOservations.length; index++) {
        const observation = this.engineeringOservations[index];
        if (observation.handoverObservationChecked) {
          receiverObservations.push({
            handoverObservationTypeId: observation.handoverObservationTypeId,
            receiverObservation: observation.handoverObservation,
            receiverUserId: this.userService.getUserProperties().userId,
            receiverObservationDatetime: datetime,
            departmentObservation: ENGINEERING_DEPARTMENT_OBSERVATION,
          } as HandoverReceiverObservation);
        }
      }
    }
    this.dialogService
      .openConfirmDialog(
        'Rechazar Handover',
        `¿Estás seguro que querés <b>rechazar</b> el Handover del <b>pozo ${
          this.handover!.wellName
        }</b>?`,
        'Sí, rechazar',
        'No'
      )
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.changeLoadingStatus(true);
          this.isDisabledButton = true;
          this.handoverService
            .rejectHandover(
              this.handover!.handoverId ? this.handover!.handoverId : 0,
              receiverObservations,
              this.handover!.handoverTypeId!
            )
            .subscribe((handoverOperationResult) => {
              if (handoverOperationResult) {
                this.emitFooterPendingChanges(false);
                let message = `${HoRejectMessages.REJECT_HO_SUCCESS_INI} ${handoverOperationResult.handover.handoverId} ${HoRejectMessages.REJECT_HO_SUCCESS_END}`;
                if (!handoverOperationResult.notificationSent) {
                  message += `\nLa acción fue realizada, pero no se ha podido notificar vía mail a ${handoverOperationResult.handover.toAreaName}.\nPor favor, notifique a ${PAE_SUPPORT_EMAIL} de este inconveniente.`;
                }
                this.notificationService.notify(
                  message,
                  HoRejectMessages.SUCCESS_NOTIFICATION
                );

                setTimeout(() => {
                  this.changeLoadingStatus(false);
                  this.goToHome();
                }, SUCCESS_TIME_MESSAGE);
              } else {
                this.changeLoadingStatus(false);
                this.isDisabledButton = false;
                this.notificationService.notify(
                  `${HoRejectMessages.REJECT_HO_ERROR_INI} \n${HoRejectMessages.REJECT_HO_ERROR_END}`,
                  HoRejectMessages.ERROR_NOTIFICATION
                );
              }
            });
        }
      });
  }

  accept(): void {
    const receiverObservations: HandoverReceiverObservation[] = [];
    const datetime = this.datepipe.transform(Date.now(), 'yyyy-MM-dd HH:mm:ss');
    if (this.firstReject || !this.isHo3) {
      if (this.isDr && this.isEngineerUser) {
        for (
          let index = 0;
          index < this.engineeringOservations.length;
          index++
        ) {
          const observation = this.engineeringOservations[index];
          if (observation.handoverObservationChecked) {
            receiverObservations.push({
              handoverObservationTypeId: observation.handoverObservationTypeId,
              receiverObservation: observation.handoverObservation,
              receiverUserId: this.userService.getUserProperties().userId,
              receiverObservationDatetime: datetime,
              departmentObservation: ENGINEERING_DEPARTMENT_OBSERVATION,
            } as HandoverReceiverObservation);
          }
        }
      } else {
        for (let index = 0; index < this.observations.length; index++) {
          const observation = this.observations[index];
          if (observation.handoverObservationChecked) {
            receiverObservations.push({
              handoverObservationTypeId: observation.handoverObservationTypeId,
              receiverObservation: observation.handoverObservation,
              receiverUserId: this.userService.getUserProperties().userId,
              receiverObservationDatetime: datetime,
              departmentObservation: this.isDr
                ? !this.isEngineerUser
                  ? OPERATIONS_DEPARTMENT_OBSERVATION
                  : ENGINEERING_DEPARTMENT_OBSERVATION
                : null,
            } as HandoverReceiverObservation);
          }
        }
      }
    } else {
      for (let index = 0; index < this.observations.length; index++) {
        const observation = this.observations[index];
        if (observation.handoverObservationChecked) {
          receiverObservations.push({
            handoverObservationTypeId: observation.handoverObservationTypeId,
            receiverObservation: observation.handoverObservation,
            receiverUserId: this.userService.getUserProperties().userId,
            receiverObservationDatetime: datetime,
            departmentObservation: OPERATIONS_DEPARTMENT_OBSERVATION,
          } as HandoverReceiverObservation);
        }
      }
      for (let index = 0; index < this.engineeringOservations.length; index++) {
        const observation = this.engineeringOservations[index];
        if (observation.handoverObservationChecked) {
          receiverObservations.push({
            handoverObservationTypeId: observation.handoverObservationTypeId,
            receiverObservation: observation.handoverObservation,
            receiverUserId: this.userService.getUserProperties().userId,
            receiverObservationDatetime: datetime,
            departmentObservation: ENGINEERING_DEPARTMENT_OBSERVATION,
          } as HandoverReceiverObservation);
        }
      }
    }
    this.dialogService
      .openConfirmDialog(
        'Aceptar Handover',
        `¿Estás seguro que querés <b>aceptar</b> el Handover del <b>pozo ${
          this.handover!.wellName
        }</b>?`,
        'Sí, aceptar',
        'No'
      )
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.changeLoadingStatus(true);
          this.isDisabledButton = true;
          this.handoverService
            .acceptHandover(
              this.handover!.handoverId ? this.handover!.handoverId : 0,
              this.handover!.wellId,
              this.handover!.wellUwi,
              this.handover!.wellName,
              this.handover!.handoverTypeId,
              receiverObservations
            )
            .subscribe((handoverOperationResult) => {
              if (handoverOperationResult) {
                this.emitFooterPendingChanges(false);
                let message = `${HoAcceptMessages.ACCEPT_HO_SUCCESS_INI} ${handoverOperationResult.handover.handoverId} ${HoAcceptMessages.ACCEPT_HO_SUCCESS_END}`;
                if (!handoverOperationResult.notificationSent) {
                  message += `\nLa acción fue realizada, pero no se ha podido notificar vía mail a ${handoverOperationResult.handover.toAreaName}.\nPor favor, notifique a ${PAE_SUPPORT_EMAIL} de este inconveniente.`;
                }
                this.notificationService.notify(
                  message,
                  HoAcceptMessages.SUCCESS_NOTIFICATION
                );

                setTimeout(() => {
                  this.changeLoadingStatus(false);
                  this.goToHome();
                }, SUCCESS_TIME_MESSAGE);
              } else {
                this.changeLoadingStatus(false);
                this.isDisabledButton = false;
                this.notificationService.notify(
                  `${HoAcceptMessages.ACCEPT_HO_ERROR_INI} \n${HoAcceptMessages.ACCEPT_HO_ERROR_END}`,
                  HoAcceptMessages.ERROR_NOTIFICATION
                );
              }
            });
        }
      });
  }

  getLastObservations(): void {
    this.handoverService
      .getLastObservations(
        this.handover!.handoverId!,
        OPERATIONS_DEPARTMENT_OBSERVATION,
        this.isDr || this.isHo3
      )
      .subscribe((observations: HandoverObservation[]) => {
        this.firstTime =
          observations.filter((o) => o.handoverId != null).length == 0;
        this.observations = observations;
        this.observations.forEach((o) => {
          o.handoverObservationTypeDescription =
            o.handoverObservationTypeDescription.substring(0, 1).toUpperCase() +
            o.handoverObservationTypeDescription.substring(1);
          o.handoverObservationChecked = false;
          o.handoverObservation = '';
        });
      });
  }

  getLastEngineeringObservations(): void {
    this.handoverService
      .getLastObservations(
        this.handover!.handoverId!,
        ENGINEERING_DEPARTMENT_OBSERVATION,
        this.isDr || this.isHo3
      )
      .subscribe((observations: HandoverObservation[]) => {
        this.firstTime =
          observations.filter((o) => o.handoverId != null).length == 0;
        this.engineeringOservations = observations;
        this.engineeringOservations.forEach((o) => {
          o.handoverObservationTypeDescription =
            o.handoverObservationTypeDescription.substring(0, 1).toUpperCase() +
            o.handoverObservationTypeDescription.substring(1);
          o.handoverObservationChecked = false;
          o.handoverObservation = '';
        });
      });
  }

  goToHome(): void {
    this.router.navigateByUrl(`/`);
  }

  isDisabledRejectButton(): boolean {
    return (
      this.isDisabledButton ||
      (this.observations.filter((o) => o.handoverObservationChecked).length ==
        0 &&
        this.engineeringOservations.filter((o) => o.handoverObservationChecked)
          .length == 0) ||
      this.observations.filter(
        (o) =>
          o.handoverObservationChecked && o.handoverObservation.trim() == ''
      ).length > 0 ||
      this.engineeringOservations.filter(
        (o) =>
          o.handoverObservationChecked && o.handoverObservation.trim() == ''
      ).length > 0
    );
  }

  isDisabledAcceptButton(): boolean {
    return (
      this.isDisabledButton ||
      this.observations.filter(
        (o) =>
          o.handoverObservationChecked && o.handoverObservation.trim() == ''
      ).length > 0 ||
      this.engineeringOservations.filter(
        (o) =>
          o.handoverObservationChecked && o.handoverObservation.trim() == ''
      ).length > 0
    );
  }

  resizeFooter(): void {
    this.fullscreen = !this.fullscreen;
  }

  getObservations(): void {
    this.handoverService
      .getObservations(this.handover!.handoverId!)
      .subscribe((historyObservations: HandoverHistoryObservation[]) => {
        this.historyObservations = historyObservations;
        this.firstReject = this.historyObservations.length == 0;
        this.historyObservations.forEach((o) => {
          o.handoverObservationTypeDescription =
            o.handoverObservationTypeDescription.substr(0, 1).toUpperCase() +
            o.handoverObservationTypeDescription.substr(
              1,
              o.handoverObservationTypeDescription.length - 1
            );
        });
        // Group observations by type and count
        const countsHo = historyObservations.reduce(
          (result: any, handoverObservation: any) => {
            const prop = handoverObservation.handoverObservationTypeId;
            if (!result.hasOwnProperty(prop)) {
              result[prop] = 0;
            }
            result[prop]++;
            return result;
          },
          {}
        );
        this.viewHistory = Object.keys(countsHo).map((k) => {
          return {
            handoverObservationTypeId: Number(k),
            viewHistory: countsHo[k] > 1,
          };
        });
      });
  }

  viewHistoryHoType(handoverObservationTypeId: number): boolean {
    return (
      this.viewHistory.filter(
        (vh) =>
          vh.handoverObservationTypeId == handoverObservationTypeId &&
          vh.viewHistory
      ).length > 0
    );
  }

  viewObservationsHistory(handoverObservationTypeId: number): void {
    this.dialogService.openHandoverHistoryObservationsDialog(
      handoverObservationTypeId == HANDOVER_OBSERVATION_WELL_CONDITION
        ? HANDOVER_OBSERVATION_WELL_CONDITION_DIALOG_TITLE
        : HANDOVER_OBSERVATION_DATA_DIALOG_TITLE,
      this.historyObservations.filter(
        (ho) => ho.handoverObservationTypeId == handoverObservationTypeId
      ),
      '',
      '',
      this.handover!.handoverTypeId!
    );
  }

  buildRejectToolTip(): void {
    const activateRejectOkTextInfo =
      this.observations.some(
        (obs) =>
          obs.handoverObservationChecked && obs.handoverObservation.trim() != ''
      ) ||
      this.engineeringOservations.some(
        (obs) =>
          obs.handoverObservationChecked && obs.handoverObservation.trim() != ''
      );
    if (activateRejectOkTextInfo) {
      this.rejectButtonToolTip = HANDOVER_REJECT_OK_MESSAGE;
    } else {
      this.rejectButtonToolTip = HANDOVER_REJECT_NOT_OK_MESSAGE;
    }
  }

  changeLoadingStatus(isLoading: boolean): void {
    this.isLoadingEmmitter.emit(isLoading);
  }

  getGeneralSectionComment(): void {
    this.handoverService
      .getSectionsComments(this.handover!.handoverId!)
      .subscribe((sectionsComments: SectionsComments[]) => {
        this.generalComment = sectionsComments.find(
          (c) => c.handoverSectionId == HANDOVER_SECTION_GENERAL
        )?.comment;
      });
  }

  showTab(tab: string): void {
    this.operationsVisible = tab == 'operations';
  }

  //TODO: Refactorizar. Tambien se usa en handover-card
  getInitialsOfName(fullName: string | undefined): string {
    let initialsName = '';

    if (fullName) {
      if (fullName == 'mí') {
        const name = this.userService.getUserProperties().firstname;
        const lastName = this.userService.getUserProperties().lastname;
        const nameInitial = name ? name.charAt(0).toUpperCase() : '';
        const lastNameInitial = lastName
          ? lastName.charAt(0).toUpperCase()
          : '';
        initialsName = nameInitial + lastNameInitial;
        initialsName = initialsName ? initialsName : fullName.toUpperCase();
      } else {
        const fullNameList: string[] = fullName.split(' ');
        // Take initials for the fist name and the lastname.
        initialsName =
          fullNameList[0].charAt(0).toUpperCase() +
          fullNameList[fullNameList.length - 1].charAt(0).toUpperCase();
      }
    } else {
      initialsName = 'N/N';
    }
    return initialsName;
  }

  cantEditObservations(): boolean {
    if (!this.isDr) {
      return false;
    }
    return !(
      (this.operationsVisible && !this.isEngineerUser) ||
      (!this.operationsVisible && this.isEngineerUser)
    );
  }

  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    if (this.handover?.handoverId && file) {
      this.changeLoadingStatus(true);
      const formData = new FormData();
      formData.append('file', file);
      if (this.isDr) {
        if (!this.isEngineerUser)
          formData.append(
            'departmentObservation',
            JSON.stringify(OPERATIONS_DEPARTMENT_OBSERVATION)
          );
        else
          formData.append(
            'departmentObservation',
            JSON.stringify(ENGINEERING_DEPARTMENT_OBSERVATION)
          );
      }
      /* Para el caso de ho3 para la imagen No hace falta dividir entre operaciones e ingenieria ya que van a compartir la imagen */
      if (this.isHo3) {
        formData.append(
          'departmentObservation',
          JSON.stringify(ALL_DEPARTMENT_OBSERVATION)
        );
      }
      this.handoverService
        .saveObservationAttachment(this.handover?.handoverId, formData)
        .subscribe(
          (uploaded: ObservationAttachment[]) => {
            if (uploaded) {
              this.getObservationAttachments();
            }
          },
          (response: HttpErrorResponse) => {
            this.notificationService.notify(response.error.message, false);
          }
        );
      this.changeLoadingStatus(false);
    }
  }

  getObservationAttachments(): void {
    if (this.handover?.handoverId) {
      this.changeLoadingStatus(true);
      this.handoverService
        .getObservationAttachments(this.handover?.handoverId)
        .subscribe((files: ObservationAttachment[]) => {
          if (files) {
            this.observationOperationsAttachment = files.filter(
              (o) =>
                o.departmentObservation == OPERATIONS_DEPARTMENT_OBSERVATION
            );

            this.observationEngineerAttachment = files.filter(
              (o) =>
                o.departmentObservation == ENGINEERING_DEPARTMENT_OBSERVATION
            );

            this.observationAttachment = files;
          }
          this.changeLoadingStatus(false);
        });
    }
  }

  deleteObservationAttachment(file: any): void {
    const dialogRef = this.dialogService.openConfirmDialog(
      'Observaciones',
      `¿Está seguro de que desea eliminar el archivo?`
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        if (!this.handover?.handoverId) {
          return;
        }
        this.changeLoadingStatus(true);
        this.handoverService
          .deleteObservationAttachment(this.handover?.handoverId, file)
          .subscribe((res: boolean) => {
            if (res) {
              if (this.isDr) {
                if (!this.isEngineerUser)
                  delete this.observationOperationsAttachment;
                else delete this.observationEngineerAttachment;
              }
              if (this.isHo3) {
                delete this.observationAttachment;
              }
              this.getObservationAttachments();
            }
            this.changeLoadingStatus(false);
          });
      }
    });
  }

  onChangeValue() {
    const emitPendingChanges =
      this.observations.some((obs) => obs.handoverObservationChecked) ||
      this.engineeringOservations.some((obs) => obs.handoverObservationChecked);

    this.emitFooterPendingChanges(emitPendingChanges);
  }
}
